var _PhotoContentManager_currentPhoto;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
class PhotoContentManager {
    constructor() {
        _PhotoContentManager_currentPhoto.set(this, writable(null));
    }
    get currentPhoto() {
        return __classPrivateFieldGet(this, _PhotoContentManager_currentPhoto, "f");
    }
    setCurrentPhoto(photo) {
        __classPrivateFieldGet(this, _PhotoContentManager_currentPhoto, "f").set(photo);
    }
}
_PhotoContentManager_currentPhoto = new WeakMap();
export const PhotoContentService = new PhotoContentManager();
